import { publicClient, privateClient } from "../../configs/axiosConfig";

const rosterEndpoints = {
  getClosedDates: "v2/closed-dates",
  createClosedDate: "v2/closed-dates",
  deleteClosedDate: (date) => `v2/closed-dates/${date}`,
  getPublicHolidays: (year) => `v2/closed-dates/public-holidays/${year}`,

  saveStaffRoster: "v2/closed-dates/staff",

  // ✅ NEW
  getStaffRosterOverrides: ({ year, month }) =>
    `v2/closed-dates/staff-overrides?year=${year}&month=${month}`,

  // ✅ NEW — reset staff to normal hours
  resetStafftoNormalHours: (staffId) => `v2/closed-dates/staff/${staffId}`,
};

const rosterApi = {
  /* -------------------------------
   * GET closed dates (operator)
   * ----------------------------- */
  getClosedDates: async () => {
    try {
      const response = await privateClient.get(rosterEndpoints.getClosedDates);
      return { response };
    } catch (err) {
      console.error("Error fetching closed dates:", err);
      return { err };
    }
  },

  /* -------------------------------
   * CREATE closed date (operator roster)
   * payload: { startDate, endDate }
   * ----------------------------- */
  createClosedDate: async (payload) => {
    try {
      const response = await privateClient.post(
        rosterEndpoints.createClosedDate,
        payload
      );
      return { response };
    } catch (err) {
      console.error("Error creating closed date:", err);
      return { err };
    }
  },

  /* -------------------------------
   * DELETE closed date (by YYYY-MM-DD)
   * ----------------------------- */
  deleteClosedDate: async (date) => {
    try {
      const response = await privateClient.delete(
        rosterEndpoints.deleteClosedDate(date)
      );
      return { response };
    } catch (err) {
      console.error("Error deleting closed date:", err);
      return { err };
    }
  },
  getPublicHolidays: async (year) => {
    try {
      const response = await privateClient.get(
        rosterEndpoints.getPublicHolidays(year)
      );
      return { response };
    } catch (err) {
      return { err };
    }
  },

  saveStaffRoster: async (payload) => {
    try {
      const response = await privateClient.post(
        rosterEndpoints.saveStaffRoster,
        payload
      );
      return { response };
    } catch (err) {
      console.error("Error saving staff roster:", err);
      throw err;
    }
  },

  getStaffRosterOverrides: async ({ year, month }) => {
    try {
      const response = await privateClient.get(
        rosterEndpoints.getStaffRosterOverrides({ year, month })
      );
      return { response };
    } catch (err) {
      console.error("Error loading staff roster overrides:", err);
      throw err;
    }
  },

  resetStafftoNormalHours: async (staffId) => {
    try {
      const response = await privateClient.delete(
        rosterEndpoints.resetStafftoNormalHours(staffId)
      );
      return { response };
    } catch (err) {
      console.error("Error deleting staff overrides:", err);
      throw err;
    }
  },
};

export default rosterApi;
